import {Injectable} from '@angular/core';
import {UmpireTeam} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';

@Injectable()
export class TeamService implements CrudService<UmpireTeam> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireTeam[]>> {
    return this.http
      .get(`/teams`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTeam>> {
    return this.http
      .get(`/teams/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireTeam>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTeam>> {
    return this.http
      .post(`/teams`, serialize({stuff: body}), {
        params,
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireTeam>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTeam>> {
    return this.http
      .patch(`/teams/${body.id}`, serialize({stuff: body}), {
        params,
      })
      .pipe(deserialize());
  }

  delete(teamId: string): Observable<void> {
    return this.http.delete(`/teams/${teamId}`);
  }
}
